import setActingAs from './setActingAs';

interface StopActingAsResult {
	ok: boolean;
	message?: string;
}

// Return to self -- the shared body behind both "Stop Acting As" controls: the
// banner button and the account menu row. They had the same logic twice, and both
// dropped setActingAs's `message`, so a refused stop (revoked entitlement, expired
// session, agents.cfc down) was indistinguishable from a successful one: the
// overlay came up, went down, and the user was still acting as someone else.
// Callers must surface `message` when `ok` is false.
//
// On success this does not return in the browser -- it leaves the page, which is
// what drops the acting-as state from every in-memory store.
const stopActingAs = async (): Promise<StopActingAsResult> => {
	const { ok, message } = await setActingAs('');

	if (!ok) {
		return { ok, message };
	}

	localStorage.removeItem('CurrentActingAsROLE');
	window.location.href = '/';

	return { ok };
};

export default stopActingAs;
